import React, { useState } from "react";

import Modal from "./Modal";
import "./styles.css";

export const thumbnailUrlFromFilepath = (filepath: string) => {
	if (window.location.hostname === "localhost") return "/placeholder.png";
	return `${window.location.origin.replace("https://", "https://forms.")}/thumbnails/${filepath}`;
};

export const urlFromFilepath = (filepath: string) => {
	if (window.location.hostname === "localhost") return "/placeholder.png";
	return `${window.location.origin.replace("https://", "https://forms.")}/images/${filepath}`;
};

interface IProps {
	images: { filepath: string }[];
	index?: number;
}

const Carousel: React.FC<IProps> = (props) => {
	const { images, index = 0 } = props;

	const [display, setDisplay] = useState<"none" | "block">("none");
	const [activeIndex, setActiveIndex] = useState<number>(index);

	const total = images.length;

	const goTo = (i: number) => setActiveIndex((i + total) % total);
	const onNext = () => goTo(activeIndex + 1);
	const onPrev = () => goTo(activeIndex - 1);

	const modal = (
		<Modal
			images={images}
			currentIndex={activeIndex}
			display={display}
			setDisplay={setDisplay}
			onNext={onNext}
			onPrev={onPrev}
			onSelectIndex={setActiveIndex}
		/>
	);

	if (total === 1) {
		return (
			<React.Fragment>
				<div id="gallery">
					<div className="gallery-image-wrapper" onClick={() => setDisplay("block")}>
						<img
							className="gallery-image"
							loading="lazy"
							src={thumbnailUrlFromFilepath(images[0].filepath)}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null;
								currentTarget.src = "/placeholder.png";
							}}
						/>
						<span className="gallery-image-number">1 / 1</span>
					</div>
				</div>
				{modal}
			</React.Fragment>
		);
	}

	return (
		<React.Fragment>
			<div id="gallery">
				<svg viewBox="0 0 24 24" focusable="false" className="icon" onClick={onPrev}>
					<path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
				</svg>
				<div className="gallery-content">
					<div className="gallery-image-wrapper" onClick={() => setDisplay("block")}>
						<img
							className="gallery-image"
							src={thumbnailUrlFromFilepath(images[activeIndex].filepath)}
							onError={({ currentTarget }) => {
								currentTarget.onerror = null;
								currentTarget.src = "/placeholder.png";
							}}
						/>
						<span className="gallery-image-number">
							{activeIndex + 1} / {total}
						</span>
					</div>
				</div>
				<svg viewBox="0 0 24 24" focusable="false" className="icon" onClick={onNext}>
					<path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
				</svg>
			</div>
			{modal}
		</React.Fragment>
	);
};

export default Carousel;
